import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { FaHome, FaPlusCircle, FaTasks, FaBell } from 'react-icons/fa';
import './BottomNav.css';

const BottomNav = () => {
  const location = useLocation();
  const path = location.pathname;

  const isActive = (to) => path === to;

  return (
    <nav className="bottom-nav">
      <Link to="/" className={`bottom-item ${isActive('/') ? 'active' : ''}`}> 
        <FaHome />
        <span>Home</span>
      </Link>

      <Link to="/pay" className={`bottom-item pay ${isActive('/pay') ? 'active' : ''}`}>
        <FaPlusCircle />
        <span>Pay</span>
      </Link>

      <Link to="/incomplete" className={`bottom-item ${isActive('/incomplete') ? 'active' : ''}`}>
        <FaTasks />
        <span>Incomplete</span>
      </Link>

      <Link to="/notification" className={`bottom-item ${isActive('/notification') ? 'active' : ''}`}>
        <FaBell />
        <span>Alerts</span>
      </Link>
    </nav>
  );
};

export default BottomNav;
